/** The one-line sign-off at the foot of every page, rendered once in App so a new page can't forget it. */
export const SIGNOFF_HANDLE = "@madebyhafiz";
export const SIGNOFF_URL = "https://www.instagram.com/madebyhafiz/";

export function SignOff() {
  return (
    <p className="signoff">
      Sincerely,{" "}
      <a href={SIGNOFF_URL} target="_blank" rel="noopener noreferrer">
        {SIGNOFF_HANDLE}
      </a>
    </p>
  );
}
